// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"c9884c7d","168":"ebe29e40"}[chunkId] + ".chunk.js";
};